<div>
  <div class="app-section-header">
    <h2>Vorgang</h2>
  </div>
  <div class="width-900" style="margin:auto">
    <exg-textarea [(ngModel)]="uiModel.vorgBeschreibung"
                  [caption]="enumSvc.getFieldCaption('Vorgang', 'vorgBeschreibung')"
                  name="vorgBeschreibung" type="text">
    </exg-textarea>
    <exg-select name="VorgangStatusSelect"
                [caption]="enumSvc.getFieldCaption('Vorgang', 'VorgangStatus')"
                [ngModel]="taskStatusDefault"
                disabled="true"
                [list]="taskStatusText"
                type="text">
    </exg-select>
    <exg-select name="VorgangTypSelect"
                [caption]="enumSvc.getFieldCaption('Vorgang', 'VorgangTyp')"
                [ngModel]="taskTypeIndex"
                (ngModelChange)="setTaskType($event)"
                [list]="enumSvc.getEnumerationList('VorgangTyp')"
                listdisplay="enmText"
                type="text">
    </exg-select>
    <exg-select name="VorgangSubTypSelect"
               [caption]="enumSvc.getFieldCaption('Vorgang', 'VorgangSubTyp')"
               [ngModel]="0"
               (ngModelChange)="setTaskSubType($event)"
               [list]="taskSubTypeText"
               type="text">
    </exg-select>
    <!--<exg-select name="BearbeiterSelect"
                caption="{{getRessource('bearbeiter')}}"
                [ngModel]="names[0]"
                (ngModelChange)="setBearbeiter($event);"
                [list]="names"
                type="text">
    </exg-select>
    <exg-select name="CoBearbeiterSelect"
                caption="{{getRessource('coBearbeiter')}}"
                [ngModel]="names[0]"
                (ngModelChange)="setCoBearbeiter($event);"
                [list]="names"
                type="text">
    </exg-select>
    <exg-input [ngModel]="uiModel.vorgFrist" (ngModelChange)="setFristDate($event)"
               [ngModelOptions]="{updateOn:'blur', standalone:true}"
               [caption]="enumSvc.getFieldCaption('Vorgang', 'vorgFrist')"
               name="vorgFrist" type="date" [isEpoch]=true>
    </exg-input>-->
  </div>
</div>
